import { useEffect, useState } from "react";
import { getRates } from "../api";

export function useRates() {
    const [rates, setRates] = useState(null);

    useEffect(() => {
        getRates().then(data => setRates(data));
    }, []);

    return rates;
}
